import { useResetRecoilState, useSetRecoilState } from "recoil";
import { history, useFetchWrapper } from "_helpers";
import { storesAtom, userAtom } from "_state";
import { useAlertActions } from "./alert.actions";
import { useTokenActions } from "./token.actions";

export { useLoginActions };

function useLoginActions() {
    const baseUrl = `${process.env.REACT_APP_API_URL}/eInvoice/api/v4`;
    const fetchWrapper = useFetchWrapper();
    const setStores = useSetRecoilState(storesAtom);
    const tokenActions = useTokenActions();
    const setUser = useSetRecoilState(userAtom);
    const alertActions = useAlertActions();


    return {
        getAllStores,
        login,
        logout,
        resetUsers: useResetRecoilState(storesAtom)
    }

    function getAllStores() {
        alertActions.clear();
        return fetchWrapper.get(`${baseUrl}/POS`).then(setStores);
    }

    function login({ tienda = 1, ticket }) {
        alertActions.clear();
        //console.table(tienda, ticket, total);
        return tokenActions.getToken()
            .then(() => {
                return fetchWrapper
                    .get(`${baseUrl}/Consulta/${tienda}/${ticket}`)
                    .then(response => {
                        if (!response.pdf) {
                            //Solicitar el PDF
                            const uuid = response.uuid
                            return fetchWrapper.post(`${baseUrl}/PDF/Individual`, { uuid })
                                .then(pdf => {
                                    response.pdf = pdf.replace('"', '');
                                    localStorage.setItem('files', JSON.stringify(response));
                                    setUser(response);
                                    history.push('/Download');
                                });
                        } else {
                            localStorage.setItem('files', JSON.stringify(response));
                            setUser(response);
                            history.push('/Download');
                            return Promise.resolve();
                        }
                    });
            });
    }

    function logout() {
        alertActions.clear();
        tokenActions.removeToken();
        history.push('/');
    }
}